import Stack from '@mui/material/Stack';

interface Props {
    errorMessage: string;
    errorDetails?: Error;
}

export const ErrorLocal = (props: Props) => {
    console.error(props.errorMessage, props.errorDetails);

    return (
        <div className="aq-content">
            <Stack className="error-local" spacing={2}>
                <h3>An unexpected error occured</h3>
                <p>{props.errorMessage}</p>
                <p>Please refresh page to try again.</p>
            </Stack>
        </div>
    );
};
